module.exports = __webpack_public_path__ + "img/slogn1.a0b6b998.png";